import { QueryHookOptions } from '@apollo/client';

export const defaultQueryConfig: Partial<QueryHookOptions> = {
  errorPolicy: 'all',
  returnPartialData: true,
  notifyOnNetworkStatusChange: true,
};
